import { getLanguageDescriptionField, indexWasMatched } from "@/overlay/components/WeatherParameterSearchForm/util";
import { classNames } from "@/utility/jsx";
import { searchEngineWeatherModels } from "@/weather-parameters";
import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";
import type { CrossModelParameterSpecification } from "@mm/api-layers.meteomatics.com";
import type { ExactMatchResult } from "@mm/weather-parameter-utils";
import type { SearchResults } from "@mm/weather-parameter-utils";

export function BasicSearchResultList(props: {
  results: SearchResults;
  /**
   * A callback for when the user selected a parameter group model.
   * E.g) Temperture
   */
  onSelectLayerGroup: (result: CrossModelParameterSpecification) => void;
  /**
   * A callback for when the user selected the exact weather parameter.
   * E.g) t_2m:C
   */
  onSelectExactParamMatch: (result: ExactMatchResult) => void;
}) {
  const locale = useLingui().i18n.locale;
  const descriptionField = getLanguageDescriptionField(locale.substring(0, 2));

  if (props.results.fuzzy.length === 0 && props.results.regular.length === 0) {
    return (
      <span>
        <Trans>No parameter matches the given search term</Trans>
      </span>
    );
  }

  function onSelectLayerGroup(result: CrossModelParameterSpecification) {
    props.onSelectLayerGroup(result);
  }

  function onSelectExactParam(result: ExactMatchResult) {
    props.onSelectExactParamMatch(result);
  }

  // TODO: render weather models with their display name
  return (
    <div className="parameter-add__search-result listing listing--actionable box-section--breakout">
      {props.results.regular.map((res) => (
        <div
          className="search-result__item"
          key={`regular:${res.layerGroup.name}`}
          onClick={() => onSelectExactParam(res)}
        >
          <div className="search-result__item__title">{res.layerGroup[descriptionField] as string}</div>
          <div className="search-result__item__layers">
            {res.layerGroup.layers.map((layer, layerIdx) => (
              <span
                key={layer.format + layer.unit}
                className={classNames("layer", indexWasMatched(res.matchingLayers, layerIdx) && "layer--highlighted")}
              >
                {layer.format}
              </span>
            ))}
          </div>
          <div className="search-result__item__models">
            {res.layerGroup.available_models?.map((model) => (
              <span key={model}>{searchEngineWeatherModels.matchModelExactly(model)?.name ?? model}</span>
            ))}
          </div>
        </div>
      ))}
      {props.results.fuzzy.map((res) => (
        <div
          className="search-result__item"
          key={`fuzzy:${res.item.name}`}
          onClick={() => onSelectLayerGroup(res.item)}
        >
          <div className="search-result__item__title">{res.item[descriptionField] as string}</div>
          <div className="search-result__item__layers">
            {res.item.layers.map((layer, layerIdx) => (
              <span key={layer.format + layer.unit} className="layer">
                {layer.format}
              </span>
            ))}
          </div>
          <div className="search-result__item__models">
            {res.item.available_models?.map((model) => (
              <span key={model}>{searchEngineWeatherModels.matchModelExactly(model)?.name ?? model}</span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
